/**
 * @generated SignedSource<<e3ad345667cc1a204b05076252805c01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRealtimeUpdater$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraIssueEdge";
  } | null | undefined> | null | undefined;
  readonly jql: string | null | undefined;
  readonly " $fragmentType": "IssueRealtimeUpdater";
};
export type IssueRealtimeUpdater$key = {
  readonly " $data"?: IssueRealtimeUpdater$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRealtimeUpdater">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueRealtimeUpdater",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "0dd12505590cf3a645eeeccd268004c4";

export default node;
